import { render, staticRenderFns } from "./ImpresionArqueoNew.vue?vue&type=template&id=1e52ece4&"
import script from "./ImpresionArqueoNew.vue?vue&type=script&lang=js&"
export * from "./ImpresionArqueoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports